const OPEN = 'OPEN';
const CLOSED = 'CLOSED';

const SideBarStatus = { OPEN, CLOSED };
export default SideBarStatus;
